import { useRef, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";

export function useCsvImport({ parse, endpoint, entity, onOpenChange, onDone, extraBody }) {
  const [rows, setRows] = useState([]);
  const [parseErrors, setParseErrors] = useState([]);
  const [csvText, setCsvText] = useState("");
  const [busy, setBusy] = useState(false);
  const fileRef = useRef(null);
  const applyText = (text, parseEmpty = false) => {
    setCsvText(text);
    const result = text.trim() || parseEmpty ? parse(text) : { rows: [], errors: [] };
    setRows(result.rows);
    setParseErrors(result.errors);
  };
  const reset = () => {
    applyText("");
    if (fileRef.current) fileRef.current.value = "";
  };
  const onFile = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => applyText(String(reader.result || ""), true);
    reader.readAsText(file);
  };
  const submit = async () => {
    setBusy(true);
    try {
      const body = { rows, ...(typeof extraBody === "function" ? extraBody() : {}) };
      const { data } = await api.post(endpoint, body);
      const { imported, updated = 0, skipped = [] } = data;
      const parts = [`Imported ${imported} ${entity}`];
      if (updated) parts.push(`${updated} updated`);
      if (skipped.length) toast.warning(`${parts.join(" · ")} — ${skipped.length} skipped (${skipped[0].reason}${skipped.length > 1 ? ", …" : ""})`);
      else toast.success(parts.join(" · "));
      onOpenChange(false);
      reset();
      onDone();
    } catch (error) { toast.error(errMsg(error)); }
    finally { setBusy(false); }
  };
  return { rows, parseErrors, csvText, busy, fileRef, reset, onFile, onPaste: applyText, submit };
}
